import React from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import SaleBanner from './components/SaleBanner';
import DesktopToolSidebar from './components/DesktopToolSidebar';
import Login from './pages/Login';
import Signup from './pages/Signup';
import GoogleSignup from './pages/GoogleSignup';
import Terms from './pages/Terms';
import HomeWithStoryCTA from './pages/HomeWithStoryCTA';
import RecruitmentList from './pages/RecruitmentList';
import RecruitmentDetail from './pages/RecruitmentDetail';
import CreateRecruitment from './pages/CreateRecruitment';
import EditRecruitment from './pages/EditRecruitment';
import ApplicationHistory from './pages/ApplicationHistory';
import Profile from './pages/Profile';
import EditProfile from './pages/EditProfile';
import ChangeEmail from './pages/ChangeEmail';
import ChangePassword from './pages/ChangePassword';
import MountainLog from './pages/MountainLog';
import Achievements from './pages/Achievements';
import Contact from './pages/Contact';
import CommunityGuidelines from './pages/CommunityGuidelines';
import FirstTimeGuide from './pages/FirstTimeGuide';
import Faq from './pages/Faq';
import StorySubmission from './pages/StorySubmission';
import AdminKpiReport from './pages/AdminKpiReport';
import Chat from './pages/Chat';
import ChatList from './pages/ChatList';
import Notifications from './pages/Notifications';
import ResetPassword from './pages/ResetPassword';
import VerifyEmail from './pages/VerifyEmail';
import UserProfile from './pages/UserProfile';
import MyRecruitments from './pages/MyRecruitments';
import GroupChat from './pages/GroupChat';
import ProtectedRoute from './components/ProtectedRoute';
import BottomNav from './components/BottomNav';
import Footer from './components/Footer';
import RouteAnalytics from './components/RouteAnalytics';
import ToastHost from './components/ToastHost';
import './App.css';

function AppLayout() {
  const location = useLocation();
  const hideSidebar = [
    '/login',
    '/signup',
    '/reset-password',
    '/google-signup',
    '/verify-email',
    '/change-email',
    '/change-password',
    '/create-recruitment',
    '/profile/edit',
  ].some((prefix) => location.pathname.startsWith(prefix)) ||
    location.pathname.startsWith('/edit-recruitment/') ||
    location.pathname.startsWith('/chat/') ||
    location.pathname.startsWith('/group-chat/') ||
    location.pathname.startsWith('/ops-report');

  return (
    <div className="app">
      <RouteAnalytics />
      <ToastHost />
      <SaleBanner />
      <Navbar />
      <div className={`app-layout ${hideSidebar ? 'app-layout--full' : ''}`}>
        <main className="main-content">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/google-signup" element={<GoogleSignup />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/" element={<HomeWithStoryCTA />} />
            <Route path="/mountain-log" element={<MountainLog />} />
            <Route path="/achievements" element={<Achievements />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/community-guidelines" element={<CommunityGuidelines />} />
            <Route path="/first-time-guide" element={<FirstTimeGuide />} />
            <Route path="/faq" element={<Faq />} />
            <Route
              path="/ops-report"
              element={
                <ProtectedRoute>
                  <AdminKpiReport />
                </ProtectedRoute>
              }
            />
            <Route
              path="/stories/submit"
              element={
                <ProtectedRoute>
                  <StorySubmission />
                </ProtectedRoute>
              }
            />
            <Route path="/recruitments" element={<RecruitmentList />} />
            <Route path="/recruitments/:id" element={<RecruitmentDetail />} />
            <Route
              path="/create-recruitment"
              element={
                <ProtectedRoute>
                  <CreateRecruitment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/edit-recruitment/:id"
              element={
                <ProtectedRoute>
                  <EditRecruitment />
                </ProtectedRoute>
              }
            />
            <Route
              path="/history"
              element={
                <ProtectedRoute>
                  <ApplicationHistory />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile/edit"
              element={
                <ProtectedRoute>
                  <EditProfile />
                </ProtectedRoute>
              }
            />
            <Route
              path="/change-email"
              element={
                <ProtectedRoute>
                  <ChangeEmail />
                </ProtectedRoute>
              }
            />
            <Route
              path="/change-password"
              element={
                <ProtectedRoute>
                  <ChangePassword />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chat/:chatId"
              element={
                <ProtectedRoute>
                  <Chat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/group-chat/:recruitmentId"
              element={
                <ProtectedRoute>
                  <GroupChat />
                </ProtectedRoute>
              }
            />
            <Route
              path="/chats"
              element={
                <ProtectedRoute>
                  <ChatList />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute>
                  <Notifications />
                </ProtectedRoute>
              }
            />
            <Route
              path="/my-recruitments"
              element={
                <ProtectedRoute>
                  <MyRecruitments />
                </ProtectedRoute>
              }
            />
            <Route path="/users/:uid" element={<UserProfile />} />
          </Routes>
        </main>
        {!hideSidebar && <DesktopToolSidebar />}
      </div>
      <Footer />
      <BottomNav />
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppLayout />
      </Router>
    </AuthProvider>
  );
}

export default App;
